import { createFileRoute, useParams } from '@tanstack/react-router'

import { PairResultView } from '@/features/directory/components/pair-result-view'
import { usePairCompare } from '@/features/directory/queries'

export const Route = createFileRoute('/_authed/directory/compare/$a/$b')({
  component: () => {
    const { a, b } = useParams({ from: '/_authed/directory/compare/$a/$b' })
    const { data, isLoading, isError } = usePairCompare(a, b)
    if (isLoading) return <p className="p-6">Ladowanie...</p>
    if (isError || !data) return <p className="p-6 text-red-300">Nie udalo sie wczytac porownania.</p>
    return <PairResultView data={data} />
  },
})
